import { c as _c } from "react/compiler-runtime";
import type { HostedBusinessOwner, OnboardingRequirementCollectBusinessData } from '@onefootprint/request-types';
import { PageShell } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import { BosList } from './components/bos-list';
import { EditBosForm } from './components/edit-bos-form';
import { getDefaultFormValues, isBoEditable } from './utils/get-default-form-values';
export type ManageBusinessOwnersProps = {
  authToken: string;
  businessOwners: HostedBusinessOwner[];
  requirement: OnboardingRequirementCollectBusinessData;
  onSubmit: (operations: {
    updateOrCreateOperations: Array<{
      uuid: string;
      data: Partial<Record<string, string | undefined>>;
      ownershipStake?: number;
    }>;
    deleteOperations: string[];
  }) => Promise<void>;
  onBosListSubmit: (payload: {
    uuid: string;
    ownershipStake: number;
  }) => Promise<void>;
  onDone: () => void;
  isBusy: boolean;
};
export const ManageBusinessOwners = t0 => {
  const $ = _c(35);
  const {
    authToken,
    businessOwners,
    requirement: t1,
    onSubmit,
    onBosListSubmit,
    onDone,
    isBusy
  } = t0;
  const {
    minimumBoStake,
    allowDuplicateContactInfo
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "collectBusinessData.pages.manageBos"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t2);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      keyPrefix: "collectBusinessData.beneficialOwners.form"
    };
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const {
    t: tForm
  } = useTranslation("idv2", t3);
  let t4;
  if ($[2] !== businessOwners) {
    t4 = businessOwners.filter(_temp);
    $[2] = businessOwners;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const immutableBos = t4;
  let t5;
  if ($[4] !== t) {
    t5 = t(_temp2);
    $[4] = t;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== minimumBoStake || $[7] !== t) {
    t6 = t(_temp3, {
      minimumBoStake
    });
    $[6] = minimumBoStake;
    $[7] = t;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== tForm) {
    t7 = tForm(_temp4);
    $[9] = tForm;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t7) {
    t8 = {
      type: "submit",
      text: t7,
      form: "manage-business-owners-form"
    };
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== immutableBos || $[14] !== onBosListSubmit) {
    t9 = immutableBos.length > 0 && <BosList immutableBos={immutableBos} onSubmit={onBosListSubmit} />;
    $[13] = immutableBos;
    $[14] = onBosListSubmit;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== businessOwners) {
    t10 = getDefaultFormValues(businessOwners);
    $[16] = businessOwners;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== allowDuplicateContactInfo || $[19] !== authToken || $[20] !== businessOwners || $[21] !== minimumBoStake || $[22] !== onDone || $[23] !== onSubmit || $[24] !== t10) {
    t11 = <EditBosForm authToken={authToken} existingBos={businessOwners} onDone={onDone} defaultFormValues={t10} allowDuplicateContactInfo={allowDuplicateContactInfo} minimumBoStake={minimumBoStake} onSubmit={onSubmit} formId="manage-business-owners-form" />;
    $[18] = allowDuplicateContactInfo;
    $[19] = authToken;
    $[20] = businessOwners;
    $[21] = minimumBoStake;
    $[22] = onDone;
    $[23] = onSubmit;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <div className="flex flex-col gap-4 w-full">{t9}{t11}</div>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== isBusy || $[30] !== t12 || $[31] !== t5 || $[32] !== t6 || $[33] !== t8) {
    t13 = <PageShell title={t5} subtitle={t6} cta={t8} isLoading={isBusy}>{t12}</PageShell>;
    $[29] = isBusy;
    $[30] = t12;
    $[31] = t5;
    $[32] = t6;
    $[33] = t8;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
};
function _temp(bo) {
  return !isBoEditable(bo);
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0.subtitle;
}
function _temp4($_1) {
  return $_1.continue;
}